import { Box, List, useMediaQuery, useTheme } from "@mui/material";
import { CollectionsBookmark, Groups, Home as HomeIcon } from "@mui/icons-material";
import { Settings } from "lucide-react";
import { useLocation } from "react-router-dom";
import NavItem from "./SidebarNavItem";
import {
  GoldSidebarDivider,
  SidebarShell,
  useCloseDrawerOnRouteChange,
} from "./sidebarDesign";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@/shared/constants";
import { isNavItemSelected } from "@/shared/utils/isNavItemSelected";

type TalentSidebarProps = {
  open: boolean;
  handleClose?: () => void;
  toggleDrawer?: () => void;
};

const TalentSidebar = ({ open, handleClose, toggleDrawer }: TalentSidebarProps) => {
  const { t } = useTranslation("sidebar");
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const showRailTooltip = !isMobile && !open;
  const navOpen = !showRailTooltip;

  useCloseDrawerOnRouteChange(isMobile, location.pathname, handleClose);

  const exploreItems = [
    { text: t("lobby"), icon: <HomeIcon />, path: ROUTES.LOBBY },
    { text: t("halls"), icon: <Groups />, path: ROUTES.TALENTS },
  ];

  const workspaceItems = [
    { text: t("charm"), icon: <CollectionsBookmark />, path: ROUTES.CHARM },
  ];

  const bottomItems = [
    { text: t("settings"), icon: <Settings size={20} />, path: ROUTES.SETTINGS },
  ];

  return (
    <SidebarShell
      open={open}
      isMobile={isMobile}
      onClose={handleClose}
      onToggle={toggleDrawer}
      body={
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4.25,
            pt: 3.5,
            px: 0.25,
          }}
        >
          <Box>
            <List disablePadding sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {[...exploreItems, ...workspaceItems].map((item) => (
                <NavItem
                  key={item.path}
                  variant="landing"
                  item={item}
                  open={navOpen}
                  selected={isNavItemSelected(location.pathname, item.path)}
                  onClick={isMobile ? handleClose : undefined}
                />
              ))}
            </List>
          </Box>
        </Box>
      }
      footer={
        <Box sx={{ mb: 2 }}>
          <GoldSidebarDivider width="85%" open={navOpen} />
          <List disablePadding sx={{ display: "flex", flexDirection: "column", gap: 1, px: 0.25 }}>
            {bottomItems.map((item) => (
              <NavItem
                key={item.path}
                variant="landing"
                item={item}
                open={navOpen}
                selected={isNavItemSelected(location.pathname, item.path)}
                onClick={isMobile ? handleClose : undefined}
              />
            ))}
          </List>
        </Box>
      }
    />
  );
};

export default TalentSidebar;
